import React from 'react'
import SOAReportComponent from '../../Components/Reports/SOAReportComponent'

function SOAReportPage() {
    return (
        <SOAReportComponent />
    )
}

export default SOAReportPage